import { defineStore } from 'pinia'
import type { UserProfile, OrganizationProfile } from '@repo/types'

export const useSessionStore = defineStore('session', {
  state: () => ({
    active: false, // Is the logged-in user viewing their own profile?
    agent: null as UserProfile | null,
    organization: null as OrganizationProfile | null,
    members: [] as UserProfile[],
  }),
  getters: {
    company(): OrganizationProfile['general'] | undefined {
      return this.organization?.general
    },
    companyLogo(): string | undefined {
      return this.company?.organizationImageFile?.url
    },
    agentAvatar(): string {
      if (this.agent?.avatar?.url) {
        return this.agent.avatar.url
      } else if (this.agent?.avatar?.data) {
        return 'data:image/png;base64,' + this.agent.avatar.data
      } else {
        return '/images/avatar.svg'
      }
    },
    publicPage(): boolean {
      return this.agent?.openroom?.status !== 'private'
    },
    address(): string {
      return [this.company?.prefecture, this.company?.city, this.company?.street].filter(Boolean).join('')
    },
    mapUrl(): string | null {
      return this.address
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.address)}`
        : null
    },
  },
})
